import { render, staticRenderFns } from "./IndexComponent.vue?vue&type=template&id=c1ce5cac&scoped=true"
import script from "./IndexComponent.vue?vue&type=script&lang=js"
export * from "./IndexComponent.vue?vue&type=script&lang=js"
import style0 from "./IndexComponent.vue?vue&type=style&index=0&id=c1ce5cac&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1ce5cac",
  null
  
)

export default component.exports